import {
  Box,
  Card,
  Container,
  Grid,
  Image,
  Text,
  Loader,
  Group,
  Button,
  Breadcrumbs,
} from "@mantine/core";
import React, { useEffect, useState, useContext } from "react";
import { api } from "../services/master.service";
import { Link, useNavigate } from "react-router-dom";
import { IconShoppingCartPlus } from "@tabler/icons-react";
import { CartContext } from "../App";
import { showErrorToast, showSuccessToast } from "../utilities/Toast";

function Bundles() {
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { setCartItemCount } = useContext(CartContext);

  useEffect(() => {
    api.get_bundles().then((res) => {
      if (res.data.success) {
        setBundles(res.data.data);
      }
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <Box h={400} display="flex" sx={{ alignItems: "center", justifyContent: "center" }}>
        <Loader />
      </Box>
    );
  }

  const addBundleToCart = (bundle, e) => {
    e.stopPropagation();

    api
      .add_bundle_to_cart(bundle.id)
      .then((res) => {
        if (res.data.success) {
          // setCartItemCount(res.data.data?.item_count || 0);
          const data = res.data.data;
          const productRows = data.cartitem?.filter(item => item.bundle === null).length ?? 0;
          const bundleRows = data.cart_bundles?.length ?? 0;
          setCartItemCount(productRows + bundleRows);

          showSuccessToast({
            title: "Success",
            message: "Bundle added to cart successfully",
          });
        } else if (res.data.code === 401) {
          navigate("/login");
        } else {
          showErrorToast({
            title: "Error",
            message: res.data.message,
          });
        }
      })
      .catch(() => {
        showErrorToast({
          title: "Error",
          message: "Server error",
        });
      });
  };

  return (
    <Container size="xl" mt={170}>
      {/* Breadcrumbs */}
      <Box mb={24}>
        <Breadcrumbs separator="/">
          <Link to="/" style={{ textDecoration: "none", color: "inherit", fontSize: 14 }}>
            Home
          </Link>
          <Link
            to="/categories"
            style={{ textDecoration: "none", color: "inherit", fontSize: 14 }}
          >
            Categories
          </Link>
          <Text size={14} color="dimmed">
            Bundles
          </Text>
        </Breadcrumbs>
      </Box>

      <Text size="xl" fw={600} mb={20}>
        Bundles
      </Text>

      <Grid>
        {bundles.map((b) => (
          <Grid.Col span={12} sm={6} md={4} lg={3} key={b.id}>
            <Card
              withBorder
              radius="md"
              p="sm"
              h={420}
              sx={{
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                transition: "0.2s ease",
                "&:hover": {
                  borderColor: "#3AA44A",
                  boxShadow: "0 6px 14px rgba(0,0,0,0.1)",
                },
              }}
              onClick={() => navigate(`/bundle/${b.id}`)}
            >
              {/* Image */}
              <Box
                sx={{
                  border: "1px solid #e5e5e5",
                  borderRadius: 6,
                  height: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 12,
                }}
              >
                <Image
                  src={b.image}
                  alt={b.name}
                  fit="contain"
                  height={170}
                  withPlaceholder
                />
              </Box>

      {/* Name & count */}
<Box>
  <Text fw={600} size="sm" lineClamp={2}>
    {b.name}
  </Text>

  <Text size="xs" color="dimmed" mt={4}>
    {b.product_count} Products
  </Text>

  {/* 🔥 Product names inside bundle */}
  <Box mt={6}>
    {b.products?.slice(0, 3).map((p) => (
      <Text
        key={p.id}
        size="xs"
        color="gray"
        lineClamp={1}
      >
        • {p.title}
      </Text>
    ))}

  </Box>
</Box>


              {/* Price */}
              <Box mt="auto">
                <Group position="apart">
                  <Text size="xs" td="line-through" color="red">
                    ₹{b.original_price}
                  </Text>
                  <Text fw={600} color="green">
                    ₹{b.offer_price}
                  </Text>
                </Group>

                {/* Add to cart */}
                <Button
                  mt={12}
                  fullWidth
                  color="green"
                  leftIcon={<IconShoppingCartPlus size={16} />}
                  onClick={(e) => addBundleToCart(b, e)}
                  disabled={b.bundle_count <= 0}
                >
                  {b.bundle_count <= 0 ? "Sold Out" : "Add to Cart"}
                </Button>
              </Box>
            </Card>
          </Grid.Col>
        ))}
      </Grid>
    </Container>
  );
}

export default Bundles;
